import type { FunctionComponent } from "react";

export const ARB = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24px"
			height="24px"
			viewBox="0 0 24 24"
		>
			<title>Arbitrum Logo</title>
			<g fill="none">
				<path
					fill="#12aaff"
					d="m13.49 13.521l-.973 2.651a.3.3 0 0 0 0 .234l1.667 4.566l1.94-1.112l-2.324-6.339a.167.167 0 0 0-.25-.077a.17.17 0 0 0-.06.077m1.944-4.466a.167.167 0 0 0-.25-.078a.17.17 0 0 0-.061.078l-.973 2.65a.3.3 0 0 0 0 .233l2.74 7.478l1.934-1.111l-3.39-9.256z"
				/>
				<path
					fill="#9dcced"
					d="M12 3.116q.075 0 .14.04l7.5 4.36a.27.27 0 0 1 .139.24v8.483a.27.27 0 0 1-.14.239l-7.5 4.377a.28.28 0 0 1-.277 0l-7.501-4.37a.27.27 0 0 1-.139-.24v-8.49c0-.1.056-.188.139-.239l7.5-4.36a.26.26 0 0 1 .14-.045zM12 2a1.56 1.56 0 0 0-.76.205L3.871 6.444a1.52 1.52 0 0 0-.76 1.312v8.483c0 .54.287 1.045.76 1.317l7.368 4.24a1.52 1.52 0 0 0 1.521 0l7.368-4.24a1.5 1.5 0 0 0 .76-1.317V7.756a1.51 1.51 0 0 0-.76-1.312l-7.368-4.24A1.56 1.56 0 0 0 12 2"
				/>
				<path
					fill="#213147"
					d="m7.128 19.428l.678-1.85l1.361 1.128l-1.272 1.167z"
				/>
				<path
					fill="#fff"
					d="M11.384 6.999H9.512a.34.34 0 0 0-.311.227l-4 11.073l1.927 1.128l4.411-12.195a.18.18 0 0 0-.02-.158a.17.17 0 0 0-.14-.075zm3.267 0h-1.867a.34.34 0 0 0-.311.222L7.895 19.855l1.933 1.128l4.978-13.756a.17.17 0 0 0-.078-.209a.2.2 0 0 0-.077-.019"
				/>
			</g>
		</svg>
	);
};
